import { FC } from 'react';

export type ExpandIconProps = {};

export const ExpandIcon: FC<ExpandIconProps> = ({}) => (
  <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M53.3333 37.3333V44.8C53.3333 47.7869 53.3333 49.2804 52.752 50.4213C52.2407 51.4248 51.4248 52.2407 50.4213 52.752C49.2804 53.3333 47.7869 53.3333 44.8 53.3333H37.3333M26.6667 10.6667H19.2C16.2131 10.6667 14.7196 10.6667 13.5787 11.248C12.5752 11.7593 11.7593 12.5752 11.248 13.5787C10.6667 14.7196 10.6667 16.2131 10.6667 19.2V26.6667M40 24L56 8M56 8H40M56 8V24M24 40L8 56M8 56H24M8 56L8 40"
      stroke="url(#paint0_linear_101_44428)"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="3"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_101_44428"
        x1="52.8193"
        x2="3.14062"
        y1="53"
        y2="42.8411"
      >
        <stop stop-color="#3EBDDA" />
        <stop offset="1" stop-color="#548CE4" />
      </linearGradient>
    </defs>
  </svg>
);
